import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

interface ILoading { show: boolean; msg: string; }


@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  constructor() {
  }

  private _isVisible = new Subject<ILoading>();

  get isVisible(): Observable<ILoading> {
    return this._isVisible.asObservable();
  }

  show(msg?: string): void {
    this._isVisible.next({show: true, msg: msg});
  }

  hide(): void {
    this._isVisible.next({show: false, msg: undefined});
  }
}
